

module.exports = __webpack_require__.stylable.create(
    "divider793843741",
    {"classes":{"root":"divider793843741__root","item":"divider793843741__item","date":"divider793843741__date"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    2,
    "divider793843741",
    null
);
